<template>
  <section class="throughput" data-test="throughput-tile">
    <header class="tp-head">
      <p class="tp-eyebrow">Flow · last {{ windowDays }} days</p>
    </header>
    <div class="tp-tiles">
      <div class="tp-tile">
        <span class="tp-label">Completed</span>
        <span class="tp-value" data-test="throughput-count">{{ completedCount }}</span>
        <span class="tp-sub">issues delivered</span>
      </div>
      <div class="tp-tile">
        <span class="tp-label">Completed SP</span>
        <span class="tp-value" data-test="throughput-sp">{{ completedSp }}</span>
        <span class="tp-sub">story points delivered</span>
      </div>
      <div class="tp-tile">
        <span class="tp-label">Work in progress</span>
        <span class="tp-value" data-test="wip-count">{{ wipCount }}</span>
        <span class="tp-sub">non-terminal issues</span>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { KanbanThroughput, KanbanWip } from "@/api/types";

const props = defineProps<{
  throughput?: KanbanThroughput;
  wip?: KanbanWip;
}>();

function dash(n: number | null | undefined): string {
  return typeof n === "number" ? String(n) : "—";
}
function fmtSp(n: number | null | undefined): string {
  if (typeof n !== "number") return "—";
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}

const windowDays = computed(() => props.throughput?.window_days ?? 14);
const completedCount = computed(() => dash(props.throughput?.count));
const completedSp = computed(() => fmtSp(props.throughput?.sp));
const wipCount = computed(() => dash(props.wip?.count));
</script>

<style scoped>
.throughput {
  border-radius: 10px;
  padding: 16px 18px;
  background: var(--bg-elev);
  border: 1px solid var(--border);
  display: flex; flex-direction: column; gap: 12px;
}
.tp-eyebrow {
  margin: 0; font-size: 11px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--fg-subtle, #8a8f9c);
}
.tp-tiles {
  display: grid; gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
}
.tp-tile {
  display: flex; flex-direction: column; gap: 2px;
  padding: 10px 12px;
  background: var(--bg-card, #fff);
  border: 1px solid var(--border, #e4e6eb);
  border-radius: 8px;
}
.tp-label { font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; color: var(--fg-muted, #525663); }
.tp-value { font-size: 26px; font-weight: 700; color: var(--fg, #0b0c10); }
.tp-sub { font-size: 11px; color: var(--fg-muted, #525663); }
</style>
